// extracted by mini-css-extract-plugin
export var video = "styles-module--video--3zlU4";